import { Typography } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0.75rem;
`;

const StyledIconWrapper = styled.div`
  margin-right: 0.5rem;

  .MuiSvgIcon-root {
    margin-top: 0.125rem;
    width: 1.5rem;
    height: 1.5rem;
    color: #002740;
  }
`;

const StyledTitle = styled(Typography)`
  font-size: 1.125rem;
  font-weight: 600;
  color: #002740;
`;

interface IFormBoxTitleProps {
  title: string;
  icon?: React.ReactNode;
}

const FormBoxTitle = (props: IFormBoxTitleProps) => {
  const { icon, title } = props;
  return (
    <StyledTitleWrapper>
      {icon && <StyledIconWrapper>{icon}</StyledIconWrapper>}
      <StyledTitle>{title}</StyledTitle>
    </StyledTitleWrapper>
  );
};

export default FormBoxTitle;
